export default {
	address:{
		name: 'Name',
		list: 'Address List',
		address: 'Address',
		region: 'Region',
		mobile: 'Phone number',
		detail: 'Address Detail',
		save: 'Save and use this address',
		create: 'Create New Address',
		inputDetail: 'Please input detail address',
		select: 'Please input address',
		notice: 'Must be the same as shown on your identity card'
	},
	checkout: 'Check Out',
	totalPrice: 'Total Price',
	noTariff: 'Not Include Tariff And Shipping Fee',
	total: 'Total',
	products: 'Products',
	order: {
		create: 'Create Order',
		tariff: 'Tariff',
		shippingFee: 'Shipping Fee',
		discount: 'Discount',
		remarks: 'Remarks',
		couponCode: 'Coupon Code',
		useCoupon: 'Use Coupon',
		shippingMethod : 'Shipping Method',
		selfPickup: 'Self Pickup',
		mail: 'Mail',
		orderNumber: 'Order Number',
		paymentStatus:{
			status: 'Payment Status',
			P: 'Pending',
			S: 'Paid',
			F: 'Fail'
		},
		orderTime: 'Order Time',
		totalAmount: 'Total Amount',
	},
	payment:{
		pay: 'Pay',
		method: 'Payment Method',
		wechat: 'Wechat Pay',
		stripe: 'Stripe',
		cash: 'Cash',
	    makingPayment: 'Making Payment',
	    errorPayment: 'Something get wrong during the payment. Please try again',
	    errorCard: 'You may enter a wrong credit card number',
	    info: 'Payment Info',
	    orderNumber: 'Order Number',
	    actualAmount: 'Amount',
	    currency: 'Currency',
	    waitingConfirm: 'Waiting Confirm',
	    success: 'Payment Success',
	    backToOrder: 'Check My Order',
	    backToShop: 'Back to My Shop',
	   	shareMsg: 'Share your product to others may have change to earn commission！' 
	}

}



// WEBPACK FOOTER //
// ./src/Cart/langs/en_us/index.js